import { NEXT_CHECKOUT_OPTION } from "../actionTypes";
import { ActionProps } from "../../interfaces/actions.interface";

export const nextCheckoutOption = (slide: string): ActionProps => {
  return {
    type: NEXT_CHECKOUT_OPTION,
    payload: slide,
  };
};
